import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";
import {AgentType} from "../../../agents/types/agent.type";

export class AgentConfigurationProfileSelectList implements IController {

  type: any;
  agentTypes: AgentType[];
  options: any;
  selectedId: any;
  ngPlaceholder: any;
  excludeIds: any;
  onChange: Function;

  public excludedMap: any;
  private profilesRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private queryString: any;
  private selectedKeys: any;

  /* @ngInject */
  constructor(private $agentConfigurationProfiles, private $infiniteScroll, private $log) {
  }

  $onInit() {
    if (!this.options) {
      this.profilesRef = this.$agentConfigurationProfiles();
      this.loadLimit = 20;

      this.profilesRef.$query(this._getQueryPayload());
      this.infiniteScroll = this.$infiniteScroll(this.profilesRef, this.loadLimit, {getFullData: true});
    }
  }

  $onChanges(changes) {
    if (changes.excludeIds) {
      this.excludedMap = {};
      _.forEach(this.excludeIds, (id) => {
        this.excludedMap[id] = true;
      })
    }
  }

  submitQuery(query) {
    this.queryString = query;
    if (!this.options) {
      this._reload();
    }
  }

  private _reload() {
    this.profilesRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _getQueryPayload() {
    return {
      limit: this.loadLimit,
      query: this.queryString,
      type: this.type,
      agentTypes: this.agentTypes,
      sort: 'name,asc'
    };
  }
}

angular
  .module('bringoz.admin.configuration-profiles')
  .component('agentConfigurationProfileSelectList', {
    bindings: {
      type: '<?',
      options: '<?',
      selectedId: '<',
      agentTypes: '<?',
      ngPlaceholder: '@?',
      excludeIds: '<?',
      onChange: '&'
    },
    template: require('./agent-configuration-profile-select-list.html').default,
    controller: AgentConfigurationProfileSelectList
  });
